import { LoadStatus } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const loadsListStatusQueryAtom = createQueryAtomFactory(
  'trade.loadsListStatus',
  (params: {
    bookingId?: string;
    salesOrderId?: string | null;
    salesOrderIds?: string[];
    status: LoadStatus[];
  }) => ({
    loads: {
      __args: {
        filter: {
          bookingId: params.bookingId,
          salesOrderId: params.salesOrderId,
          salesOrderIds: params.salesOrderIds,
          status: params.status,
        },
        pagination: {
          limit: 25,
          offset: 0,
        },
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        documentNumber: true,
      },
    },
  }),
  {
    select: ({
      loads,
    }): {
      total: number;
      loads: {
        id: string;
        documentNumber: string;
      }[];
    } => ({
      loads: loads.entries.map((load) => ({
        id: load.id,
        documentNumber: load.documentNumber,
      })),
      total: loads.page.total ?? 0,
    }),
  },
);
